import React, { Component } from 'react';
import cookie from 'react-cookies';
import axios from 'axios';
import {API_URL} from '../../../constants';
import {updateValueInJson, hideModalPageClass, showModalPageClass, esUrl} from '../../../functions';
import { toast } from 'react-toastify';
import {showModalPaginas} from '../../../functions';
import ModalPaginas from '../../Partials/ModalPaginas';
import $ from 'jquery';

export default class SubMenu extends Component {

    constructor(props) {

        super(props);

        this.state = {
            resource: this.props.admSubMenu,
            security: cookie.load('user'),
            Validacion:{
                menu_Enlace: {
                    Error: false,
                },
                menu_Nombre: {
                    Error: false,
                }
            },
            hasError:false,
            added:false,
            hasErrorProceso:false
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.getResponse = this.getResponse.bind(this);
    }

    checkedValidate = (item) => {

        let resource = this.state.resource;
        resource[item] = !resource[item];

        this.setState({resource:resource});

    }

    getResponse = (urlSeleccionada) => {
        let resource = this.state.resource;
        resource.menu_Enlace = urlSeleccionada;

        this.setState({resource:resource});

        hideModalPageClass("submenuModal_" + this.props.keyMenu);
      }

    render() {

        let resource = this.state.resource;

        return (
            (! this.state.resource.menu_Eliminado) ?
            <React.Fragment>
				<div className="txtFile x-1">
					<input type="text" readOnly placeholder="Nuevo Sub-menú" value={resource.menu_Nombre}/>
					<div className="divBtnAccionesPopup_Panel">
						{
							this.state.resource.menu_Id ?
							<a href="#" className={resource.menu_Activo ? "btnPageModuloVer" : "btnPageModuloInactivo"} onClick={(event) => this.actualizarEstado(resource)}/>
							: null
						}
						<button className="btnPageModuloEditar btnaction" />
						{
							this.state.resource.menu_Id ?(<div>
									<a href="#" className="btnPageModuloEliminar aEliminarMenu" />
									<div className="c_divAlertaCapa">
										<div className="divAlertaCapa">
											<div className="divAlerta">
												<h2>&iquest;Seguro de eliminar?</h2>
												<div className="divAlertaBtn">
													<a href="#" className="btnAlertaAceptar"  onClick={(event) => this.eliminarRegistro(resource)}>ACEPTAR</a>
													<a href="#" className="btnAlertaCancelar">CANCELAR</a>
												</div>
											</div>
										</div>
									</div>
								</div>
							): null
						}
					</div>
				</div>
				<div className="divWrapperModuloPopup_Panel">
					<div className="btnCloseWrapperPopup_Panel" />
						<ul>
							<li>
							<div className="txtFile x-2">
								<input type="text" name="menu_Nombre" placeholder="Título del Sub-menú" value={resource.menu_Nombre} onChange={this.handleInputChange}/>
							</div>
							<div className="x-2 relative">
								<span className="openLink" onClick={() => showModalPageClass("submenuModal_" + this.props.keyMenu)}/>
								<input type="text" name="menu_Enlace" placeholder="Enlace del Sub-menú" value={resource.menu_Enlace} onChange={this.handleInputChange}/>
							</div>

                            <div className="divWrapperActive">
                                <div>
                                    <span>Enlace <br />externo?</span>
                                </div>

                                <div>
                                    <div className={this.state.resource.menu_Externo ? "containerActive backgroundPosition" : "containerActive"}
                                    onClick={() => this.checkedValidate("menu_Externo", true)}>
                                        <div className={this.state.resource.menu_Externo ? "actionActive leftPosition" : "actionActive"}/>
                                    </div>
                                    <span>{this.state.resource.menu_Externo ? "Activado" : "Desactivado"}</span>
                                </div>

                            </div>

							</li>
						</ul>
					<div className="clear" />
					<div className="divBtnAddPopup_Panel">
						<a href className="btnActivo" onClick={(event) => this.callFunctionButton(event)}>GUARDAR</a>
					</div>
				</div>
				<ModalPaginas class={"submenuModal_" + this.props.keyMenu} callback={this.getResponse.bind(this)} />
            </React.Fragment>
            : null
        )
    }

    eliminarRegistro = async(entity) => {

        const url = `${API_URL}MenuUX/Eliminar`;
		
        let dataToSave	=	updateValueInJson(entity, 'menu_UsuarioEliminacion', this.state.security.nUsuCodigo);
        const formData 	=	JSON.stringify(dataToSave);

        await axios.put(
            url,
            JSON.stringify(formData),
            { headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
                }
            }
            ).then(
                (data)=> {
                    if (data.data.isSucess)
                    {
                        let stateResponse = this.state;
                        stateResponse.resource.menu_Eliminado = true;

                        this.setState(stateResponse);
                    } else
                    {
                        toast.error('No se pudo procesar la solicitud \r');
                    }
                }
            ).catch((error)=> {
                toast.error('Error no controlado.');
                this.setState({loading:false});
            });


    }

    callFunctionButton = (event) => {

        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.menu_Nombre == '') {

            newState.Validacion.menu_Nombre = {Error: true};
            newState.hasError = true;
        }
        if (newState.resource.menu_Enlace == '' || !esUrl(newState.resource.menu_Enlace))
		{
            newState.Validacion.menu_Enlace = {Error: true};
            newState.hasError = true;
        }

        if(newState.hasError){
            this.setState(newState);
            return;
        }

        if(this.state.resource.menu_Id){
            const url = `${API_URL}MenuUX/`;
            var dataForm = this.state.resource;
            dataForm = updateValueInJson(dataForm,'menu_UsuarioEdicion', this.state.security.nUsuCodigo);

            const formData = JSON.stringify(dataForm);

            axios.put(
            url,
            JSON.stringify(formData),
            { headers: {
            'Content-Type': 'application/json; charset=UTF-8' ,
            'Accept': 'application/json'
            }
            }
            ).then(
            (data)=> {
                if (data.data.isSucess)
                {
                    let stateResponse = this.state;

                    stateResponse.added = true;
                    this.setState(stateResponse);

                    setTimeout(() => {
                        this.setState({added:false});
                    }, 5000);
					$(".btnCloseWrapperPopup_Panel").trigger("click");
					toast.success('Se actualizó correctamente');
                }
				else
                {
                    this.setState({hasErrorProceso:true});

                    setTimeout(() => {
                        this.setState({hasErrorProceso:false});
                    }, 3000);
					toast.error('Error, no se pudo actualizar.');
                }
            }
            ).catch((error)=> {
            toast.error('Error no controlado.');
            this.setState({loading:false});
            });
        }else{
            const url = `${API_URL}MenuUX/`;
            var dataForm = this.state.resource;
            dataForm = updateValueInJson(dataForm,'menu_UsuarioCreacion', this.state.security.nUsuCodigo);

            const formData = JSON.stringify(dataForm);

            axios.post(
            url,
            JSON.stringify(formData),
            { headers: {
            'Content-Type': 'application/json; charset=UTF-8' ,
            'Accept': 'application/json'
            }
            }
            ).then(
            (data)=> {
                console.log(data);
                if (data.data.isSucess)
                {
                    let stateResponse = this.state;
                    stateResponse.added = true;
                    stateResponse.resource = data.data.result;
                    setTimeout(() => {
                        this.setState({added:false});
                    }, 5000);

                    this.setState(stateResponse);
					$(".btnCloseWrapperPopup_Panel").trigger("click");
					toast.success('Se agregó correctamente');
                }
				else
                {
                    this.setState({hasErrorProceso:true});

                    setTimeout(() => {
                        this.setState({hasErrorProceso:false});
                    }, 3000);
					toast.error('Error, no se pudo agregar.');
                }
            }
            ).catch((error)=> {
            toast.error('Error no controlado.');
            this.setState({loading:false});
            });
        }

    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resource;
        copyResource[target.name] = value;

        let validaciones = this.state.Validacion;

        validaciones[target.name] = {
            Error: false,
        }

        this.setState({
            resource: copyResource,
            Validacion: validaciones,
            hasError:false
        });
    }

    actualizarEstado = (entity) => {

        const url = `${API_URL}MenuUX/`;
        entity.menu_Activo = !entity.menu_Activo;
        let dataToSave=updateValueInJson(entity, 'menu_UsuarioEdicion', this.state.security.nUsuCodigo);
        const formData = JSON.stringify(dataToSave);

        axios.put(
            url,
            JSON.stringify(formData),
            { headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
                }
            }
            ).then(
                (data)=> {

                }
            ).catch((error)=> {
                toast.error('Error no controlado.');
                this.setState({loading:false});
            });
    }
}